module.exports = __webpack_public_path__ + "img/1575778594.e9483084.jpg";